const StartupType = {
  GET_STARTUPS: 'GET_STARTUPS',
  GET_STARTUP: 'GET_STARTUP',
  CREATE_STARTUP: 'CREATE_STARTUP',
  UPDATE_STARTUP: 'UPDATE_STARTUP',
  GET_CATEGORIES: 'GET_CATEGORIES',
  GET_PHASE_OPERATIONS: 'GET_PHASE_OPERATIONS',
  GET_PROVINCES: 'GET_PROVINCES',
  GET_PROVINCE: 'GET_PROVINCE',
  CREATE_TICKET: 'CREATE_TICKET',
  GET_ROUNDS: 'GET_ROUNDS',
  UPDATE_ROUND: 'UPDATE_ROUND',
  VALUATION_STARTUP: 'VALUATION_STARTUP',
  UPDATE_VALUATION_STARTUP: 'UPDATE_VALUATION_STARTUP',
  GET_CITIES_BY_PROVINCE_ID: 'GET_CITIES_BY_PROVINCE_ID',
  GET_STARTUP_MANAGERS: 'GET_STARTUP_MANAGERS',
  GET_INVESTOR_MANAGERS: 'GET_INVESTOR_MANAGERS',
  ASSIGN_STARTUP_MANAGER: 'ASSIGN_STARTUP_MANAGER',
  GET_COMPANY_PROJECTS: 'GET_COMPANY_PROJECTS',
  GET_STARTUP_INFO: 'GET_STARTUP_INFO',
}

export default StartupType
